module.exports = __webpack_public_path__ + "img/point_counter.d6b79e42.jpeg";